import * as ambassadorWixHeadlessV1RedirectSession from './headless-v1-redirect-session-redirects.http.js';
import * as ambassadorWixHeadlessV1RedirectSessionTypes from './headless-v1-redirect-session-redirects.types.js';
import * as ambassadorWixHeadlessV1RedirectSessionUniversalTypes from './headless-v1-redirect-session-redirects.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createRedirectSession(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixHeadlessV1RedirectSessionUniversalTypes.CreateRedirectSessionRequest,
  ambassadorWixHeadlessV1RedirectSessionTypes.CreateRedirectSessionRequest,
  ambassadorWixHeadlessV1RedirectSessionUniversalTypes.CreateRedirectSessionResponse,
  ambassadorWixHeadlessV1RedirectSessionTypes.CreateRedirectSessionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixHeadlessV1RedirectSession.createRedirectSession(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/redirect-session',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  RedirectSession as RedirectSessionOriginal,
  URLDetails as URLDetailsOriginal,
  CreateRedirectSessionRequest as CreateRedirectSessionRequestOriginal,
  CreateRedirectSessionRequestIntentOneOf as CreateRedirectSessionRequestIntentOneOfOriginal,
  RedirectSessionBookingsCheckoutParams as RedirectSessionBookingsCheckoutParamsOriginal,
  SlotAvailability as SlotAvailabilityOriginal,
  Slot as SlotOriginal,
  SlotResource as SlotResourceOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  WaitingList as WaitingListOriginal,
  BookingPolicyViolations as BookingPolicyViolationsOriginal,
  NestedTimeSlot as NestedTimeSlotOriginal,
  RedirectSessionEcomCheckoutParams as RedirectSessionEcomCheckoutParamsOriginal,
  RedirectSessionEventsCheckoutParams as RedirectSessionEventsCheckoutParamsOriginal,
  RedirectSessionPaidPlansCheckoutParams as RedirectSessionPaidPlansCheckoutParamsOriginal,
  RedirectSessionLoginParams as RedirectSessionLoginParamsOriginal,
  RedirectSessionLogoutParams as RedirectSessionLogoutParamsOriginal,
  RedirectSessionAuthParams as RedirectSessionAuthParamsOriginal,
  AuthorizeRequest as AuthorizeRequestOriginal,
  Prompt as PromptOriginal,
  PromptWithLiterals as PromptWithLiteralsOriginal,
  RedirectSessionMembersAccountParams as RedirectSessionMembersAccountParamsOriginal,
  MembersAccountSection as MembersAccountSectionOriginal,
  MembersAccountSectionWithLiterals as MembersAccountSectionWithLiteralsOriginal,
  RedirectSessionStoresProductParams as RedirectSessionStoresProductParamsOriginal,
  RedirectSessionBookingsBookParams as RedirectSessionBookingsBookParamsOriginal,
  CallbackParams as CallbackParamsOriginal,
  RedirectSessionPreferences as RedirectSessionPreferencesOriginal,
  CustomMemberPaths as CustomMemberPathsOriginal,
  CreateRedirectSessionResponse as CreateRedirectSessionResponseOriginal,
  CreateAnonymousRedirectSessionRequest as CreateAnonymousRedirectSessionRequestOriginal,
  CreateAnonymousRedirectSessionRequestIntentOneOf as CreateAnonymousRedirectSessionRequestIntentOneOfOriginal,
  CreateAnonymousRedirectSessionResponse as CreateAnonymousRedirectSessionResponseOriginal,
  AttachPagesRequest as AttachPagesRequestOriginal,
  AttachPagesResponse as AttachPagesResponseOriginal,
  AttachPagesResponseStatus as AttachPagesResponseStatusOriginal,
  AttachPagesResponseStatusWithLiterals as AttachPagesResponseStatusWithLiteralsOriginal,
  ValidateCallbackURLRequest as ValidateCallbackURLRequestOriginal,
  CallbackType as CallbackTypeOriginal,
  CallbackTypeWithLiterals as CallbackTypeWithLiteralsOriginal,
  ValidateCallbackURLResponse as ValidateCallbackURLResponseOriginal,
  SignInURLRequest as SignInURLRequestOriginal,
  SignInURLResponse as SignInURLResponseOriginal,
  AttachAllTemplatesRequest as AttachAllTemplatesRequestOriginal,
  AttachAllTemplatesResponse as AttachAllTemplatesResponseOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './headless-v1-redirect-session-redirects.types.js';
